export default __webpack_public_path__ + "static/media/work_img3.58ce7f1a.jpg";